export default __webpack_public_path__ + "static/media/Image-4.8d0bafbc.png";